import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { Table, Actions, Params } from 'nallian-table-builder-ui';
import JoinRequestDetail from './JoinRequestDetail';
import AcceptJoinRequest from './AcceptJoinRequest';
import { INFINITE_SCROLL, JOIN_REQUESTS_RESOURCE, JOIN_REQUEST_ACTIONS } from '../../constants';
import apiRoutes from '../../../../app/api/routes';

const JoinRequestsOverview = ({ urlRoot, organisationId }) => {
  const { action, actionId } = useParams();

  return (
    <>
      <AcceptJoinRequest
        open={organisationId && action === JOIN_REQUEST_ACTIONS.ACCEPT_JOIN_REQUEST && actionId}
        organisationId={organisationId}
        rootUrl={urlRoot}
      />
      <JoinRequestDetail
        open={organisationId && action === JOIN_REQUEST_ACTIONS.EDIT_JOIN_REQUEST && actionId}
        organisationId={organisationId}
        rootUrl={urlRoot}
      />
      <Table
        url={apiRoutes.principalJoinRequests(organisationId)}
        infiniteScroll={INFINITE_SCROLL}
        resource={JOIN_REQUESTS_RESOURCE}
        pageSize={100}
        noUserSettings
      >
        <Actions.Link
          width="2.5rem"
          align="center"
          icon="eye"
          url={`${urlRoot}/join-requests/${JOIN_REQUEST_ACTIONS.EDIT_JOIN_REQUEST}/:id`}
        />
        <Params.String name="fullName" width="16rem" minWidth="16rem" grow />
        <Params.String
          name="primaryEmailAddress"
          label="emailAddress"
          width="20rem"
          minWidth="20rem"
          grow
        />
        <Params.String
          name="primaryPhoneNumber"
          label="phoneNumber"
          width="16rem"
          minWidth="16rem"
          grow
        />
        <Params.DateTime name="createdOn" width="16rem" grow />
      </Table>
    </>
  );
};

JoinRequestsOverview.propTypes = {
  urlRoot: PropTypes.string.isRequired,
  organisationId: PropTypes.string,
};

JoinRequestsOverview.defaultProps = { organisationId: undefined };

export default JoinRequestsOverview;
